import React from 'react'

import Loading from '../Icon/Loading'

import styles from './Spinner.module.scss'

export default () => (
  <span className={styles['icon-wrapper']}>
    <span className={styles['icon']} data-element="loading-icon">
      <Loading />
    </span>
  </span>
)
